<template>
  <div>
    <card>
      <div class="card-header">
        <h4 class="card-title">
          Découvrez de nouvelles valeurs avec les screeners
        </h4>
      </div>
      <div class="card-body">
        <div class="">
          <button
            type="button"
            @click="changeScreener('STRONG')"
            class="btn btn-info btn-outline mr-2"
            v-bind:class="{ 'btn-simple': currentScreener != 'STRONG' }"
          >
            Longues tendances
          </button>
          <button
            type="button"
            @click="changeScreener('SOON')"
            class="btn btn-info btn-outline mr-2"
            v-bind:class="{ 'btn-simple': currentScreener != 'SOON' }"
          >
            Retournement proche
          </button>
          <button
            type="button"
            @click="changeScreener('YOUNG')"
            class="btn btn-info btn-outline mr-2"
            v-bind:class="{ 'btn-simple': currentScreener != 'YOUNG' }"
          >
            Jeunes tendances
          </button>
          <button
            type="button"
            @click="changeScreener('FAKE')"
            class="btn btn-info btn-outline mr-2"
            v-bind:class="{ 'btn-simple': currentScreener != 'FAKE' }"
          >
            Faux départs
          </button>
          <button
            type="button"
            @click="changeScreener('SPEED')"
            class="btn btn-info btn-outline mr-2"
            v-bind:class="{ 'btn-simple': currentScreener != 'SPEED' }"
          >
            Les tendances rapides
          </button>
          <button
            type="button"
            @click="changeScreener('ACTION')"
            class="btn btn-info btn-outline mr-2"
            v-bind:class="{ 'btn-simple': currentScreener != 'ACTION' }"
          >
            Volumes importants
          </button>
          <button
            type="button"
            @click="changeScreener('SUPER')"
            class="btn btn-info btn-outline mr-2"
            v-if="this.mode === 'pea'"
            v-bind:class="{ 'btn-simple': currentScreener != 'SUPER' }"
          >
            Superformances
          </button>
          <button
            type="button"
            @click="changeScreener('GAP')"
            class="btn btn-info btn-outline mr-2"
            v-if="this.mode !== 'crypto'"
            v-bind:class="{ 'btn-simple': currentScreener != 'GAP' }"
          >
            Gap daily
          </button>
          <button
            type="button"
            @click="changeScreener('MOVINGAVERAGES')"
            class="btn btn-info btn-outline mr-2"
            v-bind:class="{ 'btn-simple': currentScreener != 'MOVINGAVERAGES' }"
          >
            Croisement MM
          </button>
        </div>
        <h4 class="my-2" v-if="currentScreener == 'STRONG'">
          <i class="tim-icons icon-pin text-primary"></i>
          Tendances haussières depuis au moins 30 jours, et ayant une vitesse
          d'au moins 20% par mois.
        </h4>
        <h4 class="my-2" v-if="currentScreener == 'SOON'">
          <i class="tim-icons icon-pin text-primary"></i>
          Tendances baissières dont le breakout se situe à moins de
          {{ this.mode !== "crypto" ? "3" : "6" }}% du cours actuel.
        </h4>
        <h4 class="my-2" v-if="currentScreener == 'YOUNG'">
          <i class="tim-icons icon-pin text-primary"></i>
          Tendances haussières depuis moins de 7 jours, dont le cours est
          toujours supérieur au seuil de breakout.
        </h4>
        <h4 class="my-2" v-if="currentScreener == 'FAKE'">
          <i class="tim-icons icon-pin text-primary"></i>
          Valeurs ayant réalisé un breakout, mais qui se trouvent maintenant à
          une valeur inférieure.
        </h4>
        <h4 class="my-2" v-if="currentScreener == 'SPEED'">
          <i class="tim-icons icon-pin text-primary"></i>
          Tendances haussières depuis plus d'un jour ayant une vitesse
          supérieure à 50% par mois.
        </h4>
        <h4 class="my-2" v-if="currentScreener == 'ACTION'">
          <i class="tim-icons icon-pin text-primary"></i>
          Valeurs dont le volume journalier est trois fois supérieur au volume
          moyen.
        </h4>
        <h4 class="my-2" v-if="currentScreener == 'SUPER'">
          <i class="tim-icons icon-pin text-primary"></i>
          Valeurs qui surperforment l'indice de référence (ou équivalent).
        </h4>
        <div class="row" v-if="currentScreener == 'SUPER'">
          <div class="col-md-4 col-xl-3">
            <base-input
              name="initialCapital"
              required
              label="Superformance de plus de (%)"
              placeholder="100"
              v-model="superformance.value"
            ></base-input>
          </div>
          <div class="col-md-3 col-xl-3">
            <label>Sur une période de </label>
            <div>
              <el-select
                class="select-primary"
                size="large"
                placeholder="Single Select"
                v-model="superformance.period"
              >
                <el-option
                  v-for="option in superformance.periods"
                  class="select-primary"
                  :value="option.value"
                  :label="option.label"
                  :key="'super' + option.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="col-md-3 col-xl-3">
            <label class="mb-3">Superformance continue</label>
            <br />
            <base-switch v-model="superformance.constant" type="primary">
              <i class="tim-icons icon-check-2" slot="on"></i>
              <i class="tim-icons icon-simple-remove" slot="off"></i>
            </base-switch>
            <small
              @click="openInfo('superformanceContinue')"
              class="text-primary ml-2 align-top"
              style="cursor: pointer"
            >
              <i class="tim-icons icon-bulb-63"></i>
              Fonctionnement
            </small>
          </div>
          <div class="col-md-4 col-xl-3">
            <label></label><br />
            <button @click="updateTable" type="button" class="btn btn-primary ">
              Valider
            </button>
          </div>
        </div>
        <h4 class="my-2" v-if="currentScreener == 'GAP'">
          <i class="tim-icons icon-pin text-primary"></i>
          Trouver des valeurs avec des trous de cotation proche du cours actuel.
          <br />
          <small>Ce screener n'inclut pas les gaps du jour.</small>
        </h4>
        <div class="row" v-if="currentScreener == 'GAP'">
          <div class="col-md-3 col-xl-3">
            <base-input
              name="maxDistance"
              required
              label="Distance max du GAP (%)"
              placeholder="3"
              v-model="gap.maxDistance"
            ></base-input>
          </div>
          <div class="col-md-3 col-xl-3">
            <base-input
              name="minSize"
              required
              label="Taille min du gap (%)"
              placeholder="1"
              v-model="gap.minSize"
            ></base-input>
          </div>
          <div class="col-md-3 col-xl-3">
            <label>Type de gap</label>
            <div>
              <el-select
                @input="updateTable"
                class="select-primary"
                size="large"
                placeholder="Single Select"
                v-model="gap.type"
              >
                <el-option
                  v-for="option in gap.types"
                  class="select-primary"
                  :value="option.value"
                  :label="option.label"
                  :key="'gaptype' + option.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="col-md-3 col-xl-3">
            <label>Etat du gap</label>
            <div>
              <el-select
                @input="updateTable"
                class="select-primary"
                size="large"
                placeholder="Single Select"
                v-model="gap.state"
              >
                <el-option
                  v-for="option in gap.states"
                  class="select-primary"
                  :value="option.value"
                  :label="option.label"
                  :key="'gapstate' + option.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="col-md-4 col-xl-3">
            <label></label><br />
            <button @click="updateTable" type="button" class="btn btn-primary ">
              Valider
            </button>
          </div>
        </div>
        <h4 class="my-2" v-if="currentScreener == 'MOVINGAVERAGES'">
          <i class="tim-icons icon-pin text-primary"></i>
          Trouver des valeurs dont deux moyennes mobiles se croisent.
          <br />
          <small
            >Ce screener fonctionne pendant les heures d'ouverture des
            marchés.</small
          >
        </h4>
        <div class="row" v-if="currentScreener == 'MOVINGAVERAGES'">
          <div class="col-md-3 col-xl-3">
            <base-input
              name="maxDistance"
              required
              label="Distance max (%)"
              placeholder="3"
              v-model="movingAverages.maxDistance"
            ></base-input>
          </div>
          <div class="col-md-3 col-xl-3">
            <label>Croisement de la</label>
            <div>
              <el-select
                @input="updateTable"
                class="select-primary"
                size="large"
                placeholder="Single Select"
                v-model="movingAverages.ma1"
              >
                <el-option
                  v-for="option in movingAverages.mas"
                  class="select-primary"
                  :value="option.value"
                  :label="option.label"
                  :key="'ma1' + option.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="col-md-3 col-xl-3">
            <label>Avec la</label>
            <div>
              <el-select
                @input="updateTable"
                class="select-primary"
                size="large"
                placeholder="Single Select"
                v-model="movingAverages.ma2"
              >
                <el-option
                  v-for="option in movingAverages.mas"
                  class="select-primary"
                  :value="option.value"
                  :label="option.label"
                  :key="'ma2' + option.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="col-md-3 col-xl-3">
            <label></label><br />
            <button @click="updateTable" type="button" class="btn btn-primary ">
              Valider
            </button>
          </div>
        </div>
      </div>
      <div class="card-body">
        <base-table :data="positions" thead-classes="text-primary">
          <template slot="columns" slot-scope="{ columns }">
            <th @click="updateSort('name')">
              Instrument<sort-caret
                :name="'name'"
                :current="sort.current"
                :status="sort.order"
              ></sort-caret>
              <br />&nbsp;
            </th>
            <th class="text-center">Actions<br />&nbsp;</th>
            <th class="text-right" @click="updateSort('variation')">
              Cours
              <br />
              <small>
                Variation jour
                <sort-caret
                  :name="'variation'"
                  :current="sort.current"
                  :status="sort.order"
                ></sort-caret>
              </small>
            </th>
            <th class="text-center">Tendance<br />&nbsp;</th>
            <th class="text-right" title="Titres échangés">
              <span @click="updateSort('volume')">
                Volume du jour<sort-caret
                  :name="'volume'"
                  :current="sort.current"
                  :status="sort.order"
                ></sort-caret>
              </span>
              <br />
              <small @click="updateSort('volevol')"
                >Variation<sort-caret
                  :name="'volevol'"
                  :current="sort.current"
                  :status="sort.order"
                ></sort-caret
              ></small>
            </th>
            <th
              class="text-right"
              @click="updateSort('proximity')"
              v-if="
                currentScreener !== 'GAP' &&
                  currentScreener !== 'MOVINGAVERAGES'
              "
            >
              Seuil de retournement
              <br />
              <small>
                Proximité
                <sort-caret
                  :name="'proximity'"
                  :current="sort.current"
                  :status="sort.order"
                ></sort-caret>
              </small>
            </th>
            <th
              class="text-right"
              @click="updateSort('gapproximity')"
              v-if="currentScreener === 'GAP'"
            >
              Distance du Gap<sort-caret
                :name="'gapproximity'"
                :current="sort.current"
                :status="sort.order"
              ></sort-caret>
              <br />
              <small>
                Taille
              </small>
            </th>
            <th
              class="text-right"
              @click="updateSort('maCrossProximity')"
              v-if="currentScreener === 'MOVINGAVERAGES'"
            >
              Distance du Croisement<sort-caret
                :name="'maCrossProximity'"
                :current="sort.current"
                :status="sort.order"
              ></sort-caret>
              <br />
              <small>Au cours</small>
            </th>
            <th
              class="text-right"
              @click="updateSort('duration')"
              v-if="
                currentScreener !== 'GAP' &&
                  currentScreener !== 'MOVINGAVERAGES'
              "
            >
              Durée<sort-caret
                :name="'duration'"
                :current="sort.current"
                :status="sort.order"
              ></sort-caret>
              <br /><small>Démarrage</small>
            </th>
            <th class="text-right">
              <span @click="updateSort('perf')"
                >Performance<sort-caret
                  :name="'perf'"
                  :current="sort.current"
                  :status="sort.order"
                ></sort-caret
              ></span>
              <br />
              <small @click="updateSort('speed')"
                >Vitesse<sort-caret
                  :name="'speed'"
                  :current="sort.current"
                  :status="sort.order"
                ></sort-caret
              ></small>
            </th>
          </template>

          <template slot-scope="{ row, index }" v-if="row">
            <td>
              {{ row.na }}<br />
              <market :name="row.mk"></market>
              <small title="Symbole">{{ row.sy }}</small>
            </td>
            <td class="text-center">
              <el-tooltip
                content="Afficher le graphique hebdo ou daily"
                effect="light"
                :open-delay="200"
                placement="top"
              >
                <base-button
                  type="primary"
                  icon
                  size="sm"
                  class="btn-link"
                  @click.native="
                    modals.graph = true;
                    currentInstrument = row;
                  "
                >
                  <i class="tim-icons icon-chart-bar-32"></i>
                </base-button>
              </el-tooltip>
              <el-tooltip
                content="Position et calculette"
                effect="light"
                :open-delay="200"
                placement="top"
              >
                <base-button
                  type="primary"
                  icon
                  size="sm"
                  class="btn-link"
                  @click.native="
                    modals.position = true;
                    currentInstrument = row;
                  "
                >
                  <i class="tim-icons icon-cart"></i>
                </base-button>
              </el-tooltip>
              <el-tooltip
                content="Consulter les notes"
                effect="light"
                :open-delay="200"
                placement="top"
              >
                <base-button
                  type="primary"
                  icon
                  size="sm"
                  class="btn-link"
                  @click.native="
                    modals.notes = true;
                    currentInstrument = row;
                  "
                >
                  <i class="tim-icons icon-notes"></i>
                </base-button>
              </el-tooltip>
            </td>
            <td class="text-right">
              {{
                row.li.last
                  | currency({
                    symbol: $currency(row.mk),
                    fractionCount: row.pd
                  })
              }}
              <br />
              <span
                class="text-success"
                v-bind:class="{ 'text-danger': row.dailyPercent < 0 }"
              >
                {{ row.dailyPercent }} %
              </span>
            </td>
            <td class="text-center">
              <span
                class="text-success"
                v-bind:class="{ 'text-danger': !row.in.p }"
              >
                <b>{{ row.in.p ? "Haussière" : "Baissière" }}</b> </span
              ><br />
              <span @click="smallEvolution = !smallEvolution">
                <histo-stat
                  v-for="h in row.histostat"
                  :period="h.period"
                  :periodLabel="h.periodLabel"
                  :last="row.li.last"
                  :previous="row.in.hi[h.histoindex]"
                  :indexPrevious="h.indexPrevious"
                  :indexLast="row.index.li.last"
                  :indexName="row.index.na"
                  :key="h.period"
                  :small="smallEvolution"
                  :hidden="!h.display"
                >
                </histo-stat>
              </span>
            </td>
            <td class="text-right">
              <el-tooltip
                :content="parseInt(row.li.v) + ' titres échangés aujourd\'hui'"
                effect="light"
                :open-delay="200"
                placement="top"
              >
                <span>{{
                  (row.ave / 1000)
                    | currency({
                      symbol: "k" + $currency(row.mk),
                      fractionCount: 0
                    })
                }}</span>
              </el-tooltip>
              <br />
              <el-tooltip
                :content="
                  parseInt(row.in.av) +
                    ' titres échangés par jours en moyenne la semaine dernière'
                "
                effect="light"
                :open-delay="200"
                placement="top"
              >
                <span
                  class="text-success"
                  v-bind:class="{ 'text-danger': row.volumeEvol <= 1 }"
                >
                  x{{ row.volumeEvol }}
                </span>
              </el-tooltip>
            </td>
            <td
              class="text-right"
              v-if="
                currentScreener !== 'GAP' &&
                  currentScreener !== 'MOVINGAVERAGES'
              "
            >
              {{
                row.in.p
                  ? row.in.st
                  : row.in.bk
                    | currency({
                      symbol: $currency(row.mk),
                      fractionCount: row.pd
                    })
              }}<br />
              <small>{{ row.reversePercent }} %</small>
            </td>
            <td class="text-right" v-if="currentScreener === 'GAP'">
              le
              {{
                $moment(
                  (gap.type === 1 ? row.in.gt.t : row.in.gb.t) * 1000
                ).format("ll")
              }}
              à
              <b
                >{{
                  (gap.type === 1
                    ? row.gapTopProximity
                    : row.gapBottomProximity
                  ).toFixed(2)
                }}
                %</b
              ><br />
              <small
                >{{
                  (gap.type === 1 ? row.gapTopSize : row.gapBottomSize).toFixed(
                    2
                  )
                }}
                %</small
              >
            </td>
            <td class="text-right" v-if="currentScreener === 'MOVINGAVERAGES'">
              <b>{{ row.maCrossProximity.toFixed(2) }} %</b><br />
              <small
                >{{ row.maCrossPrice.toFixed(row.pd) }}
                {{ $currency(row.mk) }}</small
              >
            </td>
            <td
              class="text-right"
              v-if="
                currentScreener !== 'GAP' &&
                  currentScreener !== 'MOVINGAVERAGES'
              "
            >
              <div v-if="row.trendDuration">
                {{ row.trendWeeklyDuration }}<br />
                <small>{{ row.bd }}</small>
              </div>
              <div v-if="!row.trendDuration">
                NA<br />
                <small>Pas assez de recul</small>
              </div>
            </td>
            <td class="text-right">
              <div v-if="row.trendDuration">
                {{ row.trendPerformance }} %<br />
                <small>{{ row.monthlySpeed }} % / mois</small>
              </div>
              <div v-if="!row.trendDuration">
                NA<br />
                <small>Pas assez de recul</small>
              </div>
            </td>
          </template>
        </base-table>
        <p class="text-danger text-center p-5" v-if="this.mode === 'pea'">
          <b>Avertissements</b><br />
          Les valeurs ayant subi des regroupements d'actions (Technicolor,
          Cybergun, Vallourec...)
          <br />peuvent apparaitre dans les screeners. Prenez bien soin de
          vérifier la solidité des entreprises sur lesquelles vous <br />
          investissez au préalable, et évitez de prendre des risques inutiles :)
        </p>

        <modal :show.sync="modals.graph" class="modal-graph">
          <trading-graph
            :instrument="currentInstrument"
            ref="screenerModalGraph"
            :use-conf="false"
          ></trading-graph>
        </modal>

        <modal :show.sync="modals.position" class="modal-position">
          <position
            v-if="currentInstrument"
            :instrument="currentInstrument"
          ></position>
        </modal>

        <modal
          :show-close="true"
          :show.sync="modals.notes"
          class="modal-position"
        >
          <h4 v-if="currentInstrument">
            Prise de notes pour {{ currentInstrument.na }}
          </h4>
          <notes-table
            v-if="currentInstrument"
            :instrument="currentInstrument"
          ></notes-table>
        </modal>
      </div>
    </card>
  </div>
</template>
<script>
import {
  BaseTable,
  BaseProgress,
  Modal,
  TradingGraph,
  Market,
  HistoStat,
  BaseSwitch
} from "@/components";
import { mapGetters } from "vuex";
import Position from "./Instruments/Position";
import moment from "moment";
import SortCaret from "../../components/Tables/SortCaret";
import { Select, Option } from "element-ui";
import NotesTable from "./Instruments/NotesTable";

export default {
  components: {
    NotesTable,
    BaseTable,
    BaseProgress,
    BaseSwitch,
    Modal,
    TradingGraph,
    Position,
    SortCaret,
    Market,
    HistoStat,
    [Option.name]: Option,
    [Select.name]: Select
  },
  computed: {
    ...mapGetters({
      livelist: "instruments/livelist",
      indexes: "instruments/indexes",
      conf: "auth/conf",
      mode: "auth/mode"
    })
  },
  data() {
    return {
      positions: [],
      currentScreener: "STRONG",
      smallEvolution: true,
      superformance: {
        period: 5,
        value: 100,
        constant: false,
        periods: [
          { value: 0, label: "1 semaine" },
          { value: 1, label: "2 semaines" },
          { value: 2, label: "1 mois" },
          { value: 3, label: "3 mois" },
          { value: 4, label: "6 mois" },
          { value: 5, label: "1 an" },
          { value: 6, label: "2 ans" }
        ]
      },
      gap: {
        maxDistance: 3,
        minSize: 1,
        type: 1,
        types: [
          { value: 1, label: "Gaps baissiers" },
          { value: 2, label: "Gaps haussiers" }
        ],
        state: 1,
        states: [
          { value: 1, label: "A combler" },
          { value: 2, label: "Dans le Gap" },
          { value: 3, label: "Comblé" }
        ]
      },
      movingAverages: {
        maxDistance: 3,
        ma1: 1,
        ma2: 2,
        mas: [
          { value: 1, label: "MM7" },
          { value: 2, label: "MM20" },
          { value: 3, label: "MM50" },
          { value: 4, label: "MM100" },
          { value: 5, label: "MM200" }
        ]
      },
      modals: {
        graph: false,
        position: false,
        notes: false
      },
      currentInstrument: null,
      sort: {
        current: "duration",
        order: -1
      }
    };
  },
  methods: {
    changeScreener(newScreener) {
      this.currentScreener = newScreener;
      // Update Sort depending on the screener
      if (this.currentScreener === "STRONG") {
        this.sort.current = "duration";
        this.sort.order = -1;
      } else if (this.currentScreener === "SOON") {
        this.sort.current = "proximity";
        this.sort.order = -1;
      } else if (this.currentScreener === "YOUNG") {
        this.sort.current = "perf";
        this.sort.order = -1;
      } else if (this.currentScreener === "FAKE") {
        this.sort.current = "name";
        this.sort.order = 1;
      } else if (this.currentScreener === "SPEED") {
        this.sort.current = "speed";
        this.sort.order = -1;
      } else if (this.currentScreener === "ACTION") {
        this.sort.current = "volevol";
        this.sort.order = -1;
      } else if (this.currentScreener === "SUPER") {
        this.sort.current = "speed";
        this.sort.order = -1;
      } else if (this.currentScreener === "GAP") {
        this.$refs.screenerModalGraph.setConf(false, { gaps: true });
        this.sort.current = "gapproximity";
        this.sort.order = -1;
      } else if (this.currentScreener === "MOVINGAVERAGES") {
        this.sort.current = "maCrossProximity";
        this.sort.order = -1;
      }
      this.updateTable();
    },
    updateTable() {
      if (this.currentScreener === "MOVINGAVERAGES") {
        this.$refs.screenerModalGraph.setConf(false, {
          mm7: this.movingAverages.ma1 == 1 || this.movingAverages.ma2 == 1,
          mm20: this.movingAverages.ma1 == 2 || this.movingAverages.ma2 == 2,
          mm50: this.movingAverages.ma1 == 3 || this.movingAverages.ma2 == 3,
          mm100: this.movingAverages.ma1 == 4 || this.movingAverages.ma2 == 4,
          mm200: this.movingAverages.ma1 == 5 || this.movingAverages.ma2 == 5
        });
      }
      this.positions = this.livelist
        .map(p => {
          const breakGap = p.in.p ? p.in.st : p.in.bk;
          const lc = p.li.c || p.li.o;
          const last = p.li.last || p.li.c;
          const dailyPercent = !lc
            ? 0
            : parseFloat(((last - lc) / lc) * 100).toFixed(2);
          const reversePercent = parseFloat(
            ((last - breakGap) / breakGap) * 100
          ).toFixed(2);
          const volumeEvol = parseFloat(p.li.v / p.in.av).toFixed(1);
          const trendDuration = (+new Date() / 1000 - p.in.bd) / 3600 / 24 / 30;
          const trendPerformance = parseFloat(
            ((last - p.in.bp) / p.in.bp) * 100
          ).toFixed(2);
          const monthlySpeed = parseFloat(
            trendPerformance / trendDuration
          ).toFixed(1);

          const index = this.getIndex(p.mk);
          let histostat = [];
          if (p && p.in && p.in.hi && index && index.in) {
            histostat = p.in.hi
              .map((h, i) => {
                let period = "1S",
                  periodLabel = "une semaine";
                if (i === 1) (period = "2S"), (periodLabel = "deux semaines");
                if (i === 2) (period = "1M"), (periodLabel = "un mois");
                if (i === 3) (period = "3M"), (periodLabel = "trois mois");
                if (i === 4) (period = "6M"), (periodLabel = "six mois");
                if (i === 5) (period = "1A"), (periodLabel = "un an");
                if (i === 6) (period = "2A"), (periodLabel = "deux ans");
                if (i === 7) (period = "5A"), (periodLabel = "cinq ans");
                return {
                  indexPrevious: index.in.hi[i],
                  indexLast: index.li.last,
                  period,
                  periodLabel,
                  display: [1, 2, 4, 5].indexOf(i) !== -1,
                  histoindex: i
                };
              })
              .reverse();
          }
          let gapBottomProximity = null;
          let gapTopProximity = null;
          let gapBottomSize = null;
          let gapTopSize = null;
          let gapBottomState = null;
          let gapTopState = null;
          if (this.currentScreener === "GAP" && p.li && p.in) {
            if (p.in.gb) {
              gapBottomProximity =
                ((p.in.gb.to - p.li.last) / p.li.last) * -100;
              gapBottomSize = ((p.in.gb.to - p.in.gb.fr) / p.in.gb.fr) * 100;
              gapBottomState =
                p.li.last <= p.in.gb.fr ? 3 : p.li.last <= p.in.gb.to ? 2 : 1;
            }
            if (p.in.gt) {
              gapTopProximity = ((p.in.gt.to - p.li.last) / p.li.last) * 100;
              gapTopSize = ((p.in.gt.fr - p.in.gt.to) / p.in.gt.to) * 100;
              gapTopState =
                p.li.last >= p.in.gt.fr ? 3 : p.li.last >= p.in.gt.to ? 2 : 1;
            }
          }

          let maCrossProximity = null;
          let maCrossPrice = null;
          let ma1 = null;
          let ma2 = null;
          if (
            this.currentScreener === "MOVINGAVERAGES" &&
            p.li &&
            p.in &&
            p.in.m &&
            p.in.m[this.movingAverages.ma1 - 1] &&
            p.in.m[this.movingAverages.ma2 - 1]
          ) {
            const x = p.in.m[this.movingAverages.ma1 - 1];
            const y = p.in.m[this.movingAverages.ma2 - 1];
            const mx = [7, 20, 50, 100, 200][this.movingAverages.ma1 - 1];
            const my = [7, 20, 50, 100, 200][this.movingAverages.ma2 - 1];
            maCrossPrice = ((my / mx) * x - y) / (1 - my / mx);
            maCrossProximity = ((maCrossPrice - p.li.last) / p.li.last) * 100;
            ma1 = (x + p.li.last) / mx;
            ma2 = (y + p.li.last) / my;
          }

          return {
            ...p,
            last,
            dailyPercent,
            bd: moment(p.in.bd * 1000).format("lll"),
            ave: p.li.v * lc,
            volumeEvol,
            trendDuration: trendDuration,
            trendWeeklyDuration: moment
              .duration(+new Date() - p.in.bd * 1000)
              .humanize(),
            trendPerformance,
            monthlySpeed,
            reversePercent,
            histostat,
            index,
            gapBottomProximity,
            gapTopProximity,
            gapBottomSize,
            gapTopSize,
            gapBottomState,
            gapTopState,
            maCrossProximity,
            maCrossPrice,
            ma1,
            ma2
          };
        })
        .filter(x => x.ave > 50000)
        // ADD FILTER depending on the screener
        .filter(x => {
          if (x.monthlySpeed > 2000) return false;

          if (this.currentScreener === "STRONG") {
            return (
              x.in.p &&
              +new Date() / 1000 - x.in.bd > 3600 * 24 * 30 &&
              x.monthlySpeed > 20
            );
          }
          if (this.currentScreener === "SOON") {
            return (
              !x.in.p &&
              x.reversePercent > (this.mode !== "crypto" ? -3 : -6) &&
              x.last < x.in.bk
            );
          }
          if (this.currentScreener === "YOUNG") {
            return (
              x.in.p &&
              +new Date() / 1000 - x.in.bd < 3600 * 24 * 7 &&
              x.monthlySpeed >= 0
            );
          }
          if (this.currentScreener === "FAKE") {
            return x.in.p && x.monthlySpeed < 0;
          }
          if (this.currentScreener === "SPEED") {
            return (
              x.in.p &&
              x.monthlySpeed > 50 &&
              +new Date() / 1000 - x.in.bd > 3600 * 24 * 1
            );
          }
          if (this.currentScreener === "ACTION") {
            return x.li.v > x.in.av * 3 && x.in.av * x.li.last > 20000;
          }
          if (this.currentScreener === "SUPER") {
            const pr = this.superformance.period;
            const constant = this.superformance.constant;
            if (
              x.in &&
              x.in.hi &&
              x.in.hi.length > pr &&
              x.in.hi[pr] &&
              x.in.bk &&
              x.index
            ) {
              if (constant) {
                for (let ix = pr; ix > 0; ix--) {
                  const perf =
                    ((x.in.hi[ix - 1] - x.in.hi[ix]) / x.in.hi[ix]) * 100;
                  const indexPerf =
                    ((x.index.in.hi[ix - 1] - x.index.in.hi[ix]) /
                      x.index.in.hi[ix]) *
                    100;
                  if (perf - indexPerf < 0) return false;
                }
              }
              const perf = ((x.last - x.in.hi[pr]) / x.in.hi[pr]) * 100;
              const indexPerf =
                ((x.index.li.last - x.index.in.hi[pr]) / x.index.in.hi[pr]) *
                100;
              return perf - indexPerf > this.superformance.value;
            }
          }
          if (this.currentScreener === "GAP") {
            if (this.gap.type === 1) {
              return (
                x.gapTopProximity && // Gap présent
                x.gapTopSize > this.gap.minSize && // taille min respectée
                x.gapTopSize < 150 && // taille max respectée
                x.gapTopProximity < this.gap.maxDistance && // Distance respectée
                x.gapTopState === this.gap.state
              ); // Etat respecté
            } else {
              return (
                x.gapBottomProximity && // Gap présent
                x.gapBottomSize > this.gap.minSize && // taille min respectée
                x.gapBottomSize < 150 && // taille max respectée
                x.gapBottomProximity < this.gap.maxDistance && // Distance respectée
                x.gapBottomState === this.gap.state
              ); // Etat respecté
            }
          }
          if (
            this.currentScreener === "MOVINGAVERAGES" &&
            x.maCrossProximity &&
            x.in.t > +new Date() / 1000 - 3600 * 24 * 3 &&
            x.maCrossProximity > -this.movingAverages.maxDistance &&
            x.maCrossProximity < this.movingAverages.maxDistance
          ) {
            return true;
          }

          return false;
        })
        .sort((a, b) => {
          if (!this.sort.current || this.sort.current === "name") {
            return a.na.localeCompare(b.na) * this.sort.order;
          }
          if (this.sort.current === "variation") {
            return (a.dailyPercent - b.dailyPercent) * this.sort.order;
          }
          if (this.sort.current === "volume") {
            return (a.ave - b.ave) * this.sort.order;
          }
          if (this.sort.current === "volevol") {
            return (a.volumeEvol - b.volumeEvol) * this.sort.order;
          }
          if (this.sort.current === "proximity") {
            return (a.reversePercent - b.reversePercent) * this.sort.order;
          }
          if (this.sort.current === "duration") {
            return (a.trendDuration - b.trendDuration) * this.sort.order;
          }
          if (this.sort.current === "perf") {
            return (a.trendPerformance - b.trendPerformance) * this.sort.order;
          }
          if (this.sort.current === "speed") {
            return (a.monthlySpeed - b.monthlySpeed) * this.sort.order;
          }
          if (this.sort.current === "gapproximity") {
            if (this.gap.type === 1)
              return (b.gapTopProximity - a.gapTopProximity) * this.sort.order;
            return (
              (b.gapBottomProximity - a.gapBottomProximity) * this.sort.order
            );
          }
          if (this.sort.current === "maCrossProximity") {
            return (a.maCrossProximity - b.maCrossProximity) * this.sort.order;
          }
        })
        .slice(0, 200);
    },
    updateSort(sortOn) {
      if (sortOn !== this.sort.current) {
        this.sort.current = sortOn;
        this.sort.order = 1;
      } else {
        this.sort.order = this.sort.order * -1;
      }
      this.updateTable();
    },
    getIndex(market) {
      if (market === "ETFP") return this.indexes.find(i => i.sy === "PXA");
      if (market === "MTAA") return this.indexes.find(i => i.sy === "PXA"); //
      if (market === "TNLB") return this.indexes.find(i => i.sy === "BEL");
      if (market === "XAIM") return this.indexes.find(i => i.sy === "N150");
      if (market === "XAMS") return this.indexes.find(i => i.sy === "AMX");
      if (market === "XBRU") return this.indexes.find(i => i.sy === "BEL");
      if (market === "XDUB") return this.indexes.find(i => i.sy === "N150");
      if (market === "XETR") return this.indexes.find(i => i.sy === "DAX");
      if (market === "XHEL") return this.indexes.find(i => i.sy === "HEX25");
      if (market === "XLIS") return this.indexes.find(i => i.sy === "N150");
      if (market === "XLON") return this.indexes.find(i => i.sy === "N150");
      if (market === "XLUX") return this.indexes.find(i => i.sy === "N150"); //
      if (market === "XMAD") return this.indexes.find(i => i.sy === "IBEX");
      if (market === "XPAR") return this.indexes.find(i => i.sy === "PXA");
      if (market === "XWBO") return this.indexes.find(i => i.sy === "BEL");
      return {};
    },
    openInfo(name) {
      if (name === "superformanceContinue") {
        this.$swal(
          "Superformance continue",
          "Activer ce filtre permet de cibler les valeurs qui superforment l'indice de référence de façon continue sur la période donnée.<br>La comparaison est réalisée sur les plages suivantes&nbsp;:<br>2A ➡️ 1A ➡️ 6M ➡️ 3M ➡️ 1M ➡️ 2S ➡️ 1S",
          "info"
        );
      }
    }
  },
  mounted() {
    this.updateTable();
  },
  watch: {
    livelist(newValue, oldValue) {
      this.updateTable();
    },
    conf(newValue, oldValue) {
      this.updateTable();
    }
  },
  metaInfo() {
    return {
      title: "Screeners Peamoni"
    };
  }
};
</script>
<style>
.small-round {
  @include diagonal-gradient($warning-states, $warning);
}
</style>
